module.exports = __webpack_public_path__ + "media/images/log/log-graph-tyubu-118d74b15b715f55fcdb1845cd2b926c.svg";